import React, { useState, useEffect, Fragment } from "react";
import "./styles.scss";
import { Link } from "react-router-dom";

import Layout from "../../components/Layout/Layout";
import OrderSiderbar from "../../components/OrderSiderbar/OrderSidebar";
import EditProfile from "../../components/EditProfile/EditProfile";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Auth from "../../config/auth";
import isEmpty from "../../utils/isEmpty";
import { isMobile, isDesktop } from "../../utils/isLayout";

const Setting = (props) => {
  const [user, setUser] = useState({});

  useEffect(() => {
    setUser(Auth.getUser());
  }, [props.user]);

  return (
    <Layout>
      <section className="order-section">
        <div className="row">
          <div className="col-md-8">
            {isMobile && <OrderSiderbar />}
            <div className="order-item">
              <div className="order-item-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="order-item">
                      <div className="order-item-body">
                        <div className="d-flex justify-content-between">
                          <p>ACCOUNT DETAILS</p>
                          <EditProfile />
                        </div>
                        <hr />
                        <div className="pl-3">
                          <p>
                            Name: <strong>{user.full_name}</strong>
                          </p>
                          <p>
                            Email: <strong>{user.email}</strong>
                          </p>
                          <p>
                            Phone: <strong>{user.phone}</strong>
                          </p>
                          <p>
                            Birthday: <strong>{user.birth_date}</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="order-item">
                      <div className="order-item-body">
                        <div className="d-flex justify-content-between">
                          <p>ADDRESS BOOK</p>
                        </div>
                        <hr />
                        <div className="pl-3">
                          <p>Your default shipping address :</p>
                          <p>
                            {" "}
                            <strong>
                              {!isEmpty(user.addresses) &&
                                user.addresses[0].line1}
                            </strong>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isDesktop && (
            <div className="col-md-4">
              <OrderSiderbar />
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

Setting.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.profile,
});

const pageActions = {};

export default connect(mapStateToProps, pageActions)(Setting);
